module.exports = __webpack_public_path__ + "img/slider-home-1@3x.ea2b52c6.png";